{
  "name": "r2it.golf.scoring.admin",
  "version": "2.5.1",
  "scripts": {
    "ng": "ng",
    "start:prod": "ng serve --configuration production",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage",
    "coverage:markdown": "node scripts/coverage-to-markdown.js",
    "coverage:pdf": "node scripts/coverage-to-pdf.js",
    "coverage:export": "npm run test:coverage && npm run coverage:markdown && npm run coverage:pdf",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run --browser chrome",
    "e2e": "ng e2e",
    "config:dev": "copy \"src\\assets\\config\\config.dev.json\" \"src\\assets\\config\\config.json\"",
    "config:staging": "copy \"src\\assets\\config\\config.staging.json\" \"src\\assets\\config\\config.json\"",
    "config:prod": "copy \"src\\assets\\config\\config.prod.json\" \"src\\assets\\config\\config.json\"",
    "config:local": "copy \"src\\assets\\config\\config.json.backup\" \"src\\assets\\config\\config.json\"",
    "config:sync": "node scripts/sync-navigation-config.js",
    "config:restore": "node scripts/sync-navigation-config.js --restore",
    "start:dev": "npm run config:dev && ng serve",
    "start:staging": "npm run config:staging && ng serve",
    "start:production": "npm run config:prod && ng serve",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.2",
    "@angular/cdk": "^21.1.2",
    "@angular/common": "^21.1.2",
    "@angular/compiler": "^21.1.2",
    "@angular/core": "^21.1.2",
    "@angular/forms": "^21.1.2",
    "@angular/platform-browser": "^21.1.2",
    "@angular/platform-browser-dynamic": "^21.1.2",
    "@angular/router": "^21.1.2",
    "@microsoft/signalr": "^8.0.7",
    "@types/file-saver": "^2.0.7",
    "@types/jszip": "^3.4.0",
    "file-saver": "^2.0.5",
    "jszip": "^3.10.1",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^26.2.0",
    "ngx-toastr": "^20.0.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.1.2",
    "@angular-devkit/core": "^21.1.2",
    "@angular/cli": "^21.1.2",
    "@angular/compiler-cli": "^21.1.2",
    "@cypress/schematic": "^3.0.0",
    "@eslint/js": "^10.0.1",
    "@testing-library/cypress": "^10.0.3",
    "@types/jest": "^29.5.14",
    "angular-eslint": "21.4.0",
    "axe-core": "^4.12.1",
    "cypress": "^14.4.1",
    "cypress-axe": "^1.7.0",
    "eslint": "^10.3.0",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-preset-angular": "^16.0.0",
    "puppeteer": "^24.15.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.59.2"
  }
}
